import React from 'react'
import { connect } from 'react-redux'
import { getMobileOperatingSystem } from 'util/mobile'
import { clearHeader, clearSkip } from 'actions/general'

function mapStateToProps(state) {
  return {
    redirectUrl: state.general.get('portalUrl', null),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
  }
}

class Mobile extends React.PureComponent {
  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()
  }

  _getDeviceImage(device) {
    if (device === 'android') {
      return (
        <img src='assets/android_preview.png' className='mobile--preview' />
      )
    } else if (device === 'iOS') {
      return <img src='assets/iphone_preview.png' className='mobile--preview' />
    }
  }

  _getDeviceBadge(device) {
    if (device === 'android') {
      return (
        <div>
          <a href='https://play.google.com/store/apps/details?id=com.victorops.androidclient&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img
              className='mobile--badge--google'
              alt='Get it on Google Play'
              src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'
            />
          </a>
        </div>
      )
    } else if (device === 'iOS') {
      return (
        <div>
          <a href='https://itunes.apple.com/us/app/victorops/id696974262?mt=8'>
            <img
              className='mobile--badge--apple'
              alt='Get it on the App Store'
              src='assets/apple_app_store.svg'
            />
          </a>
        </div>
      )
    }
  }

  render() {
    const device = getMobileOperatingSystem()
    const deviceImage = this._getDeviceImage(device)
    const deviceBadge = this._getDeviceBadge(device)
    const redirectText = this.props.redirectText || 'or continue to the web app'

    const customLink = this.props.onSkip ? (
      <a onClick={this.props.onSkip} className='mobile--continue-text'>
        {redirectText}
      </a>
    ) : null

    const redirectLink = this.props.redirectUrl ? (
      <a href={this.props.redirectUrl} className='mobile--continue-text'>
        {redirectText}
      </a>
    ) : null

    return (
      <div className='onboarding'>
        <h1 className='heading--main'>Continue with the VictorOps app</h1>
        <span className='heading--subheading'>
          Download our mobile app to continue using VictorOps. Our customers say
          that it makes responding to incidents faster and easier.
        </span>
        {deviceBadge}
        {customLink || redirectLink}
        {deviceImage}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Mobile)
